import { render, staticRenderFns } from "./ClientAddonComponent.vue?vue&type=template&id=2b95752e&scoped=true&"
import script from "./ClientAddonComponent.vue?vue&type=script&lang=js&"
export * from "./ClientAddonComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddonComponent.vue?vue&type=style&index=0&id=2b95752e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95752e",
  null
  
)

export default component.exports